import { useEffect, useRef } from "react";
import { getAppCfg } from "../core/app-cfg";
import { EDITOR_VIEW_NAME } from "../core/constants";
import { isCloudProjectId } from "../core/project/projectid";
import { store } from "../core/state";
import { CLOUD_STATE } from "../features/cloudstorage/cloud";
import { getLauncherCodeAsync } from "../features/coderunner";

const MULTIFILE_PREFIX = '{"type":"multifile-service"';

function renderEmbed(code: string) {
  const trimmed = code.trim();
  if (trimmed.startsWith(MULTIFILE_PREFIX)) {
    try {
      const parsed = JSON.parse(code) as { type?: string; payload?: string };
      if (parsed.type === "multifile-service" && typeof parsed.payload === "string") {
        const sessionId = `embed-${Date.now()}`;
        sessionStorage.setItem(`embed-payload-${sessionId}`, parsed.payload);
        window.location.replace(
          `/assets/templates/service-app/service-app.html?sessionId=${encodeURIComponent(sessionId)}&embed=1`
        );
        return;
      }
    } catch {
      /* fall through to document.write */
    }
  }
  document.open();
  document.write(code);
  document.close();
}

export function EmbedView() {
  const [editorState] = store.useState(EDITOR_VIEW_NAME);
  const [cloudState] = store.useState(CLOUD_STATE);
  const rendered = useRef(false);

  const localProject = !isCloudProjectId(getAppCfg().projectId);
  const hasLoadError = cloudState?.loadError === "INVALID_LINK";

  useEffect(() => {
    if (rendered.current || hasLoadError) return;
    if (!localProject && !cloudState?.loaded) return;

    rendered.current = true;
    void getLauncherCodeAsync(editorState).then((code) => {
      if (code) {
        renderEmbed(code);
      }
    });
  }, [hasLoadError, localProject, cloudState?.loaded, editorState]);

  if (hasLoadError) {
    return (
      <div className="alert alert-danger m-3" role="alert">
        Link ungültig.
      </div>
    );
  }
  return null;
}
